import {
    button,
    buttonText,
} from './styles/ButtonView'
import {ButtonProps} from './types'
import React from 'react'
import {styled} from '../../stitches/config'

const StyledButton = styled('button', button)
const StyledButtonText = styled('span', buttonText)


const ButtonView = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {
        avatar: Avatar,
        avatarProps,
        color,
        children,
        css,
        dataTestid,
        disabled,
        iconLeft: IconLeft,
        iconRight: IconRight,
        margin,
        onPress,
        multiline,
        size,
        tabIndex,
        text,
        title,
        type,
        overflowVisible,
        ...other
    } = props

    return (
        <StyledButton
            color={color}
            css={css}
            data-testid={dataTestid}
            disabled={disabled}
            onClick={onPress}
            overflowVisible={overflowVisible}
            ref={ref}
            size={size}
            spacing={margin}
            tabIndex={tabIndex}
            title={title}
            type={type}
            {...other}
        >
            {!!Avatar && <Avatar {...avatarProps} />}
            {!!IconLeft && <IconLeft />}
            {!!text && <StyledButtonText color={color} data-id='button-text' disabled={disabled} multiline={multiline} overflowVisible={overflowVisible}>{text}</StyledButtonText>}
            {!!IconRight && <IconRight />}
            {children}
        </StyledButton>
    )
})

ButtonView.displayName = 'ButtonView'

export default ButtonView
